<template>
  <div class="content-page">
    <div class="course-box" v-if="isSwitch == 1">
      <div class="course-title">小程序授权发布教程</div>
      <div class="course-blak-30"></div>
      <div class="course-text">一、功能介绍</div>
      <div class="course-blak-20"></div>
      <div class="course-p">
        1、将小程序授权给第三方平台，第三方平台会自动帮助您生成店铺小程序，并提交给微信审核，省了各种折腾；
      </div>
      <div class="course-p">2、无须复杂操作，不要研究代码包，即可快速拥有你的小程序</div>

      <div class="course-blak-30"></div>
      <div class="course-text">二、功能路径</div>
      <div class="course-blak-20"></div>
      <div class="course-p">智慧数字经营商户管理后台 - 小程序 -概况</div>

      <div class="course-blak-30"></div>
      <div class="course-text">三、流程简介</div>
      <div class="course-blak-20"></div>
      <div class="course-p">1、进入智慧数字经营商户管理后台授权微信小程序</div>
      <div class="course-p">2、进入智慧数字经营商户管理后台设置小程序支付方式</div>
      <div class="course-p">3、选择小程序模板</div>
      <div class="course-p">4、发布小程序</div>
      <div class="course-p">5、等待微信审核</div>
      <div class="course-p">6、审核通过后，小程序上线</div>

      <div class="course-blak-30"></div>
      <div class="course-text">四、操作流程</div>
      <div class="course-blak-20"></div>
      <div class="course-p">
        1、如果商家已经有微信小程序，可点击&lt;立即授权&gt;按钮，用小程序管理员的微信进行扫码授权即可；
        如果没有小程序，需要先去注册小程序帐号，然后再回到该页面进行授权，可点击查看《
        <el-link @click="onSwitch(2)" :underline="false" type="primary"
          >如何在微信申请小程序</el-link
        >》。
      </div>
      <div class="course-blak-20"></div>
      <img class="course-img" src="../assets/img/appltCourse/appltCourse-img1.png" alt />
      <div class="course-blak-20"></div>
      <div class="course-p">
        <em class="course-orange">小程序管理员的微信</em>进行扫码
      </div>

      <img
        v-if="isOwn"
        class="course-img"
        src="../assets/img/appltCourse/appltCourse-img2.png"
        alt
      />
      <div class="course-p">授权后，进入基础信息 点击发布小程序 进入选择模板界面</div>
      <img class="course-img" src="../assets/img/appltCourse/appltCourse-img3.png" alt />
      <div class="course-p">选择模板后点击确定</div>
      <img class="course-img" src="../assets/img/appltCourse/appltCourse-img4.png" alt />
      <div class="course-p">更新状态为已上传 后可点击提交审核</div>
      <img class="course-img" src="../assets/img/appltCourse/appltCourse-img5.png" alt />
      <div class="course-p">更新状态为审核中，还可以撤销审核</div>
      <img class="course-img" src="../assets/img/appltCourse/appltCourse-img6.png" alt />
      <img class="course-img" src="../assets/img/appltCourse/appltCourse-img7.png" alt />
      <div class="course-p">如更新状态为：失败 修改相应原因后 可重新提交审核</div>
      <img class="course-img" src="../assets/img/appltCourse/appltCourse-img8.png" alt />
      <div class="course-p">如更新状态为：成功 可以到概况页面发布小程序</div>
      <img class="course-img" src="../assets/img/appltCourse/appltCourse-img9.png" alt />
      <div class="course-p">点击前往发布</div>
      <img class="course-img" src="../assets/img/appltCourse/appltCourse-img10.png" alt />
    </div>
    <div class="course-box" v-if="isSwitch == 2">
      <div class="course-title">如何在微信申请小程序？</div>
      <div class="course-blak-30"></div>
      <div class="course-text">
        注： 如果您已经有认证公众号，可参考此教程：
        <el-link :underline="false" type="primary" @click="onSwitch(3)"
          >如何通过已认证微信公众号快速注册小程序？</el-link
        >如果没有已认证公众号，可参考以下注册教程
      </div>
      <div class="course-blak-20"></div>

      <div class="course-p">
        一、注册小程序帐号
        <br />注册：
      </div>
      <div class="course-p">
        1、商家需要打开微信公众平台官网首页（
        <el-link :underline="false" href="https://mp.weixin.qq.com/" type="primary"
          >https://mp.weixin.qq.com/</el-link
        >）点击右上角的“立即注册”按钮；如图展示：
      </div>
      <img class="course-img" src="../assets/img/appltCourse/appltCourse-img11.png" alt />
      <div class="course-p">
        2、注册一个微信小程序帐号，注意：在注册时要选择“小程序”；
      </div>
      <img class="course-img" src="../assets/img/appltCourse/appltCourse-img12.png" alt />
      <div class="course-p">
        * 点击“查看类型区别”可查看不同类型帐号的区别和优势。点此查看详情 (
        <el-link :underline="false" href="https://mp.weixin.qq.com/" type="primary"
          >https://kf.qq.com/faq/170815aUZjeQ170815mU7bI7.html</el-link
        >)
      </div>
      <img class="course-img" src="../assets/img/appltCourse/appltCourse-img13.png" alt />
      <div class="course-p">
        3、填写账号基本信息，包含邮箱，密码。如已有微信小程序，可点击箭头指向的地方->立即登录
      </div>
      <img class="course-img" src="../assets/img/appltCourse/appltCourse-img14.png" alt />

      <div class="course-p">4、激活：到邮箱激活注册账号</div>
      <img class="course-img" src="../assets/img/appltCourse/appltCourse-img15.png" alt />

      <div class="course-p">
        * 没有收到邮件？
        <br />1）请检查邮箱地址是否正确，你可以返回重新填写 <br />2）检查你的邮件垃圾箱
        <br />3）若仍未收到确认，请尝试重新发送 <br />二、填写基本信息
        <br />企业信息，主体信息，管理员信息。如图展示的信息，需要按照操作流程每一项都填写好内容
        <br />
      </div>
      <img class="course-img" src="../assets/img/appltCourse/appltCourse-img16.png" alt />

      <div class="course-p">
        *填写好相关资料信息之后，需要使用管理员本人微信扫描二维码，注册之后，扫码的微信号将成为该账号的管理员微信号，如图：
      </div>
      <img class="course-img" src="../assets/img/appltCourse/appltCourse-img17.png" alt />
      <div class="course-p">
        *手机端扫描二维码之后，出现以下图片，按照操作提示操作即可
      </div>
      <img class="course-img" src="../assets/img/appltCourse/appltCourse-img18.png" alt />
      <img class="course-img" src="../assets/img/appltCourse/appltCourse-img19.png" alt />
      <div class="course-p">*手机扫描完成，返回原页面，完成页面如图展示：</div>

      <img class="course-img" src="../assets/img/appltCourse/appltCourse-img20.png" alt />
      <div class="course-p">*点击“继续”</div>
      <img class="course-img" src="../assets/img/appltCourse/appltCourse-img21.png" alt />

      <div class="course-p">*点击确定</div>
      <img class="course-img" src="../assets/img/appltCourse/appltCourse-img22.png" alt />
      <div class="course-p">*前往小程序完成认证</div>
      <img class="course-img" src="../assets/img/appltCourse/appltCourse-img23.png" alt />
      <div class="course-p">
        三、完成主体认证
        <br />商家根据自己的主体类型，完善主体信息和管理员信息。小程序仅开放给主体类型为公司的商家，暂不开放给个人。企业类型帐号可选择两种主体验证方式。
        <br />方式一：需要用公司的对公账户向腾讯公司打款来验证主体身份。打款信息在提交主体信息后可以查看到。
        <br />方式二：通过微信认证验证主体身份，需支付300元认证费。认证通过前，小程序部分功能暂无法使用。
        <br />
      </div>
      <div class="course-p">
        方法三：小程序已创建成功但未开通微信认证，但已跟公众号关联，可以复用公众号微信认证资质。快速认证不需要重新提交认证资质，不需要支付300元支付费用，即时生效。小程序的认证截止日期与公众号认证截止日期一致，如到期，请重新年审或再次复用资质认证。
        <el-link :underline="false" type="primary" @click="onSwitch(4)"
          >点击查看详情</el-link
        >
        <br />四、通过认证后，在智慧数字经营商户管理后台，设置商品类目
        <br />需选择“商家自营”的二级类目（类目要和自身所提供的服务一致）。小部分商家属于生活服务单独选，但千万不要选择“平台”噢。
        <br />五、进行一键授权小程序，完成发布，
      </div>
    </div>

    <div class="course-box" v-if="isSwitch == 3">
      <div class="course-title">
        通过已认证的公众号直接申请小程序，小程序就不需要再次花300元钱申请认证和支付。
      </div>
      <div class="course-blak-30"></div>
      <div class="course-p">
        1、首先登录已经认证或申请过微信支付的的公众号点此登录（注：认证订阅号不能开通微信支付）
      </div>
      <img class="course-img" src="../assets/img/appltCourse/appltCourse-img24.png" alt />
      <div class="course-p">2、点击左侧小程序按钮，再点击开通按钮</div>
      <img class="course-img" src="../assets/img/appltCourse/appltCourse-img25.png" alt />
      <div class="course-p">3、选择快速注册并认证小程序按钮</div>
      <img class="course-img" src="../assets/img/appltCourse/appltCourse-img26.png" alt />
      <div class="course-p">4、点击同意并快速创建</div>
      <img class="course-img" src="../assets/img/appltCourse/appltCourse-img27.png" alt />
      <div class="course-p">
        5、勾选需要同步的信息，选择复用资质页面，一定要勾选【微信认证资质】，这样就可以节省300元微信认证费用，无需提交材料，快速完成认证。
      </div>

      <img class="course-img" src="../assets/img/appltCourse/appltCourse-img28.png" alt />
      <div class="course-p">6、填写邮箱及密码（邮箱需要没有注册过公众号和小程序）</div>

      <img class="course-img" src="../assets/img/appltCourse/appltCourse-img29.png" alt />
      <div class="course-p">7、资料提交后，前往邮箱激活</div>

      <img class="course-img" src="../assets/img/appltCourse/appltCourse-img30.png" alt />
      <div class="course-p">8、登录申请账号邮箱，获得邮件内容，点击链接继续操作</div>

      <img class="course-img" src="../assets/img/appltCourse/appltCourse-img31.png" alt />
      <div class="course-p">9、输入您没有勾选同步的信息并进行填写</div>
      <img class="course-img" src="../assets/img/appltCourse/appltCourse-img32.png" alt />
      <div class="course-p">10、小程序注册完成</div>
      <img class="course-img" src="../assets/img/appltCourse/appltCourse-img33.png" alt />
      <div class="course-p">十一、进入小程序首页，填写小程序名称和logo等基本信息</div>
      <img class="course-img" src="../assets/img/appltCourse/appltCourse-img34.png" alt />
    </div>

    <div class="course-box" v-if="isSwitch == 4">
      <div class="course-title">
        未认证小程序关联已认证公众号，如何复用公众号资质快速进行认证？
      </div>
      <div class="course-blak-30"></div>
      <div class="course-text">一、功能介绍</div>
      <div class="course-blak-20"></div>

      <div class="course-p">
        小程序已创建成功但未开通微信认证，但已跟公众号关联，可以复用公众号微信认证资质。
        <br />快速认证不需要重新提交认证资质，不需要支付300元支付费用，即时生效。
        <br />小程序的认证截止日期与公众号认证截止日期一致，到期后，请重新年审或再次复用资质认证。
      </div>
      <div class="course-blak-30"></div>

      <div class="course-text">二、申请条件</div>
      <div class="course-blak-20"></div>

      <div class="course-p">
        1.可快速认证的小程序：企业、媒体、政府和其他组织类型的小程序；
        <br />2.要求公众号必须先完成微信认证；
        <br />3.微信公众号与小程序关联，且主体相同。
        <br />
      </div>
      <div class="course-blak-30"></div>

      <div class="course-text">三、申请入口</div>
      <div class="course-blak-20"></div>

      <div class="course-p">
        登录微信公众号后台-小程序-小程序管理-已关联小程序-详情-申请；
      </div>
      <div class="course-blak-30"></div>

      <div class="course-text">四、创建流程</div>
      <div class="course-p">
        登录公众号-小程序-小程序管理-已关联小程序-详情-申请-小程序-小程序管理-已关联小程序-详情-申请；
      </div>
      <div class="course-blak-30"></div>

      <img class="course-img" src="../assets/img/appltCourse/appltCourse-img35.png" alt />
      <img class="course-img" src="../assets/img/appltCourse/appltCourse-img36.png" alt />
      <div class="course-p">第一步：同意协议</div>
      <img class="course-img" src="../assets/img/appltCourse/appltCourse-img37.png" alt />
      <div class="course-p">第二步：管理员扫码验证</div>
      <img class="course-img" src="../assets/img/appltCourse/appltCourse-img38.png" alt />
      <div class="course-p">第三步：确认认证资料</div>
      <img class="course-img" src="../assets/img/appltCourse/appltCourse-img39.png" alt />
      <div class="course-p">
        温馨提示：
        <br />认证资料不支持修改。
        <br />复用微信认证资质不需要再次支付认证审核服务费，也不需要审核。
        <br />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      isSwitch: 1,
    };
  },
  computed: {
    ...mapState({
      isOwn: (state) => state.isOwn,
    }),
  },
  watch: {},
  mounted() {},
  methods: {
    onSwitch(i) {
      this.isSwitch = i;
    },
  },
};
</script>

<style>
/* 2020-3-31 */
.course-box {
  /* padding: 30px 600px 30px 100px; */
  padding: 30px;
}

.course-title {
  color: #666;
  font-size: 30px;
}

.course-text {
  color: #666;
  font-size: 22px;
  color: rgb(255, 101, 0);
  line-height: 36px;
}

.course-orange {
  color: rgb(255, 101, 0);
  font-style: inherit;
}

.course-p {
  color: #666;
  font-size: 14px;
  line-height: 32px;
}

.course-img {
  display: block;
  max-width: 1000px;
}

.course-blak-30 {
  height: 30px;
}

.course-blak-20 {
  height: 20px;
}

/* 2020-3-31end */
</style>
